export var TRACKING_TARGET_ALL='all';export var TRACKING_TARGET_APPS='apps';export var TRACKING_TARGET_APPS_SMARTPHONE='apps_smartphone';